import { useState, useEffect } from 'react';

import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import FormHelperText from '@mui/material/FormHelperText';
import IconButton from '@mui/material/IconButton';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import RefreshIcon from '@mui/icons-material/Refresh';

import {copyTextToClipboard} from '../shared/Utilities';
import Session from '../shared/Session';

export default function Secrets() {
    const [input, setInput] = useState('');
    const [output, setOutput] = useState("");
    const [password, setPassword] = useState("");

    const handleInputChange = (event: any) => {
      setInput(event.target.value);
    };

    const handleSubmit = () => {
        Session.api("POST", `/secret`, input, setOutput, null, true, true);
    }

    const refreshPassword = () => {
        Session.api("GET", `/password`, {}, setPassword);
    }

    useEffect(() => {
        refreshPassword();
    }, []);

    return <>
        <Typography variant="h4" align="left" gutterBottom component="h2">
            Secrets
        </Typography>
        <TextField
            fullWidth={true}
            rows={5}
            key={"secret-input"}
            id={"secret-input"}
            type="text"
            multiline
            helperText="Enter any secret in the text area. The submit button will generate a one-time URL to access the secret."
            onChange={handleInputChange}
            variant="standard"
            size="medium"
            autoFocus={true}
        />
        <Button variant="outlined" size="large" onClick={() => {handleSubmit();}}>Submit</Button>
        <br />
        <br />
        
        { output === "" ? "" : 
            <>
                <FormHelperText>Click to copy</FormHelperText>
                <Paper
                    className='sj-paper' 
                    onClick={() => { copyTextToClipboard(output); }}>
                    <pre>
                        {output}
                    </pre>
                </Paper>
                <br />
                <br />
            </>
        }
        <Typography variant="h4" align="left" gutterBottom component="h4">
            Password Generator
        </Typography>
        <br/>
        <Paper className='sj-paper'>
            <IconButton color="inherit" onClick={() => { refreshPassword(); }}>
                <RefreshIcon />
            </IconButton>
            <br/>
            <br/>
            <Typography variant="h6" align="left" gutterBottom component="h6" onClick={() => { copyTextToClipboard(password); }}>
                {password}&nbsp;
                <IconButton color="inherit">
                    <ContentCopyIcon />
                </IconButton>
            </Typography>
        </Paper>
    </>;
}
